<template>
  <div class="favorite"></div>
</template>

<script>
export default {

}
</script>

<style>

</style>